module.exports = __webpack_public_path__ + "img/title_4.100a249b.png";